import { create } from 'zustand';
import { createSelectors, StoreName, withDevtools } from '../config';
import { createChartsUiSlice, type ChartsUiSlice } from './slices/chartsUi';

export type AnalyticsStore = ChartsUiSlice;

const useAnalyticsStoreBase = create<AnalyticsStore>()(
  withDevtools(
    (set, get, store) => ({
      ...createChartsUiSlice(set, get, store),
    }),
    StoreName.Analytics
  )
);

export const useAnalyticsStore = createSelectors(useAnalyticsStoreBase);

export const getAnalyticsStoreState = (): AnalyticsStore =>
  useAnalyticsStore.getState();

export * from './slices/chartsUi';
